import type { SmartDiscoveryAnswerModelCatalogDto } from './smart-discovery.models';

/** Mirrors AppApi `SmartDiscoveryAnswerModelCatalog` for mock mode and unit tests. */
export const SMART_DISCOVERY_ANSWER_MODEL_CATALOG: SmartDiscoveryAnswerModelCatalogDto = {
  models: [
    {
      key: 'auto',
      displayName: 'Auto',
      thinkingKind: 'thinking',
      defaultThinkingId: '',
      thinkingOptions: [],
    },
    {
      key: 'sonnet',
      displayName: 'Sonnet 5',
      thinkingKind: 'thinking',
      defaultThinkingId: 'disabled',
      thinkingOptions: [
        { id: 'disabled', label: 'disabled' },
        { id: 'adaptive', label: 'adaptive' },
      ],
    },
    {
      key: 'sol',
      displayName: 'gpt-5.6-sol',
      thinkingKind: 'reasoning_effort',
      defaultThinkingId: 'none',
      thinkingOptions: [
        { id: 'none', label: 'none' },
        { id: 'low', label: 'low' },
        { id: 'high', label: 'high' },
      ],
    },
  ],
  defaultModelKey: 'auto',
  defaultVerbosity: 'Short',
};
